const lacapiProxy = {

	serviceUrl: 'http://localhost/luvitportal/LACAPI/calls.aspx',
	composerProxy: 'http://localhost:63390/api/MADRS/',
	init: () => {
		if(window.location.href.indexOf("lartorget")>-1) {
			lacapiProxy.serviceUrl = "../../LACAPI/calls.aspx";
			lacapiProxy.composerProxy = '//composer.luvit.se/composerservices/api/MADRS'
		}

		//lacapiProxy.initScorm();


		return lacapiProxy.doFetch("Init", { "clientname": "react-thingy" });
	},
	/*
	initScorm: function () {
		window.ScormStartUrl = "../../education/scorm/scorm12_loaddata.aspx";
		window.ScormSaveUrl = "../../education/scorm/scorm12_savedata.aspx";

		window.luvit = { getStartXml: lacapiProxy.getStartXml };
		window.luvitedu = { getNavTreeIdObj: function () { return ""; } };
		window.API = null;
		window.ajaxSend = function(sendMethod, url, callback, objToSend, returnXml, asyncCall, setUtf8Header) {
			if (typeof (asyncCall) == "undefined") {
				asyncCall = true;
			}
			if (typeof (setUtf8Header) == "undefined") {
				setUtf8Header = false;
			}
			// we use a javascript feature here called "inner functions"
			// using these means the local variables retain their values after the outer function
			// has returned. this is useful for thread safety, so
			// reassigning the onreadystatechange function doesn't stomp over earlier requests.

			function ajaxBindCallback() {
				if (ajaxRequest.readyState == 4) {
					if (ajaxRequest.status == 200) {
						if (ajaxCallback) {
							//If the user has been logged out, the html of the default aspx page will be returned.
							//Check for the presence of a "DOCTYPE"-string. This will most likely mean that the user has been logged out.
							if (ajaxRequest.responseText.toLowerCase().indexOf("doctype html public") > -1) { return; }

							if (returnXml) {
								ajaxCallback(ajaxRequest.responseXML);
							}
							else {
								ajaxCallback(ajaxRequest.responseText);
							}
						}
						else {
							//alert('_no callback defined');
						}
					}
					else {
						//alert("_There was a problem retrieving the xml data:\n" + ajaxRequest.status + ":\t" + ajaxRequest.statusText + "\n" + ajaxRequest.responseText);
					}
				}
			}

			// use a local variable to hold our request and callback until the inner function is called...
			var ajaxRequest = null;
			var ajaxCallback = callback;
			// bind our callback then hit the server...
			if (window.XMLHttpRequest) {
				// moz et al
				ajaxRequest = new XMLHttpRequest();
				ajaxRequest.onreadystatechange = ajaxBindCallback;
				ajaxRequest.open(sendMethod, url, asyncCall);
				if (objToSend) {
					if (setUtf8Header) {
						ajaxRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=utf-8");
					}
					ajaxRequest.send(objToSend);
				}
				else {
					ajaxRequest.send(null);
				}
			}
			else if (window.ActiveXObject) {
				// ie
				ajaxRequest = new window.ActiveXObject("Microsoft.XMLHTTP");
				if (ajaxRequest) {
					ajaxRequest.onreadystatechange = ajaxBindCallback;
					ajaxRequest.open(sendMethod, url, true);
					if (objToSend) {
						//If the post method is used, set the proper header
						if (sendMethod.toLowerCase() == "post") {
							ajaxRequest.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
						}
						ajaxRequest.send(objToSend);
					}
					else {
						ajaxRequest.send(null);
					}
				}
			}
		}
	},
	*/
	callComposerServices: (method, params) => {

		return new Promise((resolve, reject) => {
			var xhr = new XMLHttpRequest();
			var qstr = "", sep = "?"
			if (method == "GET") {
				for (var key in params) {
					qstr = qstr + sep + key + "=" + params[key];
					sep = "&"
				}
				xhr.open(method, lacapiProxy.composerProxy + qstr);
			}
			else if (method == "POST") {
				xhr.open(method, lacapiProxy.composerProxy);
			}
			xhr.setRequestHeader("Content-Type", "application/json");
			if (method == "POST") {
				xhr.send(JSON.stringify(params));
			}
			if (method == "GET") {
				xhr.send();
			}
			var _this = this;
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4) {
					if (xhr.status === 200) {
						resolve(JSON.parse(xhr.responseText));
					} else {
						reject();
					}
				}
			};
		});
	},
	doFetch: (verb, params) => {
		return fetch(lacapiProxy.serviceUrl + '/' + verb, {
			method: 'post',
			credentials: 'include',
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(params)
		}).then(response => response.json()).then(data => data.d);
	},

	getUserResults: (userId, courseId) => {
		//alert("todo")
		/*
		return new Promise((resolve, reject) => {

			var ret = { "answers": [{ "questionId": 865, "answerId": 4 }, { "questionId": 866, "answerId": 3 }, { "questionId": 867, "answerId": 3 }, { "questionId": 868, "answerId": 2 }, { "questionId": 869, "answerId": 0 }, { "questionId": 870, "answerId": 6 }, { "questionId": 871, "answerId": 3 }, { "questionId": 872, "answerId": 6 }, { "questionId": 873, "answerId": 0 }, { "questionId": 863, "answerId": 6 }], "crowdAverage": { "amount": 40, "average": 3 } };

			var clean = true;
			if(clean)
				ret.answers = [];
			resolve(ret);
		});

		//*/
		return lacapiProxy.callComposerServices("GET", { userId, courseId });
	},

	setCompleted: (courseid) => {
		return lacapiProxy.doFetch("SetCourseCompleted", { courseid })
	},


	login: (username, password) => {
		return lacapiProxy.doFetch("login", { username: username, password: password })
	},

	logout: (username, password) => {
		return lacapiProxy.doFetch("logout", { })
	},

	isLoggedIn: () => {
		return lacapiProxy.doFetch("IsLoggedIn", { allowcookies: false })
	},

	setCourseSession: (courseId) => {
		return lacapiProxy.doFetch("SetCourseSession", { "courseid": courseId })
	},

	getDocuments: () => {
		return lacapiProxy.doFetch("GetContent", { "parentreeid": "" })
	},

	startTest: (navtreeid) => {
		console.log("inuti starttest" + navtreeid);
		return lacapiProxy.doFetch("StartTest", { "navtreeid": navtreeid })
	},

	finishTest: () => {
		return lacapiProxy.doFetch("FinishTest", "");
	},

	saveQuestionAnswers: (courseId, userId, answers /* '|'-delimited answerids*/) => {
		var params = {
			courseId: parseInt(courseId.toString()),
			userId: userId,
			answers: answers
		}
		return lacapiProxy.callComposerServices("POST", params);
	},

	StartTestAndFetchQuestionDetails: (navtreeid) => {
		if(window.location.href.indexOf("localhost")>-1) {
			return new Promise((resolve, reject) => {
				resolve({"title":"test","description":"","parts":null,"items":[2570,2571,2572,2573,2574,2575,2576,2577,2578,2579],"itemDetails":[{"answers":[{"id":8371,"text":"Neutralt stämningsläge","correct":0},{"id":8372,"text":"","correct":0},{"id":8373,"text":"Ser genomgående nedstämd ut, men kan tillfälligt växla till ljusare sinnesstämning.","correct":0},{"id":8374,"text":"","correct":0},{"id":8375,"text":"Ser nedstämd och olycklig ut oavsett samtalsämne.","correct":0},{"id":8376,"text":"","correct":0},{"id":8440,"text":"Genomgående uttryck för extrem dysterhet, tungsinne eller förtvivlad olycka.","correct":0}],"selectedAnswer":-1,"id":2570,"title":"Sänkt Grundstämning","image":"","text":"Avser en sänkning av det emotionella grundläget (till skillnad från situationsutlösta affekter). Omfattar dysterhet, tungsinne och nedstämdhet, som manifesterar sig i mimik, kroppshållning och rörelsemönster. Bedömningen baseras på utpräglingsgrad och avledbarhet. Förhöjd grundstämning skattas ”0” på detta item.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8377,"text":"Neutral stämningsläge. Kan känna såväl tillfällig munterhet som nedstämdhet, allt efter omständigheterna, utan övervikt för ena eller andra stämningsläget.","correct":0},{"id":8378,"text":"","correct":0},{"id":8379,"text":"Övervägande upplevelser av nedstämdhet men ljusare stunder förekommer.","correct":0},{"id":8380,"text":"","correct":0},{"id":8381,"text":"Genomgående nedstämdhet och dyster till sinnes. Sinnesstämningen påverkas föga av yttre omständigheter.","correct":0},{"id":8382,"text":"","correct":0},{"id":8383,"text":"Genomgående upplevelser av maximal nedstämdhet.","correct":0}],"selectedAnswer":-1,"id":2571,"title":"Nedstämdhet","image":"","text":"Avser uppgift om sänkt grundstämning oavsett om den tar sig uttryck eller ej.Omfattar känslor av sorgsenhet, olycklighet, hopplöshet och hjälplöshet.Bedömningen baseras på intensitet, varaktighet och i vilken grad sinnesstämningenpåverkas av yttre omständigheter. Förhöjd sinnesstämning skattas ”0”","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8384,"text":"Mestadels lugn.","correct":0},{"id":8385,"text":"","correct":0},{"id":8386,"text":"Tillfälliga känslor av obehaglig psykisk spänning","correct":0},{"id":8387,"text":"","correct":0},{"id":8388,"text":"Ständig känsla av inre oro, någon gång så intensiv att den endast med viss svårighet kan bemästras.","correct":0},{"id":8389,"text":"","correct":0},{"id":8390,"text":"Långdragna ångestkänslor. Överväldigande känslor av skräck eller dödsångest, som ej kan bemästras på egen hand.","correct":0}],"selectedAnswer":-1,"id":2572,"title":"Ångestkänslor","image":"","text":"Avser känslor av vag psykisk olust, inre oro eller obehaglig inre spänning, ångest eller vånda, som kan stegras till det outhärdliga. Bedömningen baseras på intensitet, frekvens, duration och behov av hjälp. Särhålles från nedstämdhet(1).","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8391,"text":"Sover som vanligt.","correct":0},{"id":8392,"text":"","correct":0},{"id":8393,"text":"Måttliga insomningssvårigheter eller kortare, ytligare eller oroligare sömn än vanligt.","correct":0},{"id":8394,"text":"","correct":0},{"id":8395,"text":"Minskad sömntid (minst två timmar mindre än normalt). Vaknar ofta under natten även utan yttre störningar.","correct":0},{"id":8396,"text":"","correct":0},{"id":8397,"text":"Mindre än två till tre timmars nattsömn totalt.","correct":0}],"selectedAnswer":-1,"id":2573,"title":"Minskad nattsömn","image":"","text":"Avser uppgifter om minskad sömntid eller sömndjup i förhållande till de ordinära sömnvanorna. Ökad sömn skattas ”0” på detta item.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8398,"text":"Normalt eller ökad aptit.","correct":0},{"id":8399,"text":"","correct":0},{"id":8400,"text":"Dålig matlust.","correct":0},{"id":8401,"text":"","correct":0},{"id":8402,"text":"Aptit saknas nästan helt, maten smakar inte, måste tvinga sig att äta.","correct":0},{"id":8403,"text":"","correct":0},{"id":8404,"text":"Måste övertalas att äta något överhuvudtaget. Matvägran","correct":0}],"selectedAnswer":-1,"id":2574,"title":"Minskad aptit","image":"","text":"Avser upplevelser av att aptiten är sämre än normalt","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8405,"text":"Inga koncentrationssvårigheter","correct":0},{"id":8406,"text":"","correct":0},{"id":8407,"text":"Tillfälligt svårt att hålla tankarna samlade vid t ex läsning eller TV-tittande.","correct":0},{"id":8408,"text":"","correct":0},{"id":8409,"text":"Uppenbara koncentrationssvårigheter som försvårar läsning eller samtal.","correct":0},{"id":8410,"text":"","correct":0},{"id":8411,"text":"Kontinuerliga, invalidiserande koncentrationssvårigheter.","correct":0}],"selectedAnswer":-1,"id":2575,"title":"Koncentrationssvårigheter","image":"","text":"Avser svårigheter att samla tankarna eller koncentrera sig. Bedömningen baseras på intensitet, frekvens och i vilken mån olika aktiviteter försvåras.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8412,"text":"Ingen svårighet att ta itu med nya uppgifter","correct":0},{"id":8413,"text":"","correct":0},{"id":8414,"text":"Lätta igångsättningssvårigheter","correct":0},{"id":8415,"text":"","correct":0},{"id":8416,"text":"Svårt att komma igång även med enkla rutinuppgifter,som kräver stor ansträngning","correct":0},{"id":8417,"text":"","correct":0},{"id":8418,"text":"Oförmögen att ta initiativ till de enklaste aktiviteter. Kan inte påbörja någon verksamhet på egen hand","correct":0}],"selectedAnswer":-1,"id":2576,"title":"Initiativlöshet","image":"","text":"Avser den subjektiva upplevelsen av initiativlöshet, känslan av att behöva ett motstånd, innan en aktivitet kan påbörjas.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8419,"text":"Normalt intresse för omvärlden och för andra människor.","correct":0},{"id":8420,"text":"","correct":0},{"id":8421,"text":"Svårigheter att finna nöje i sådant som vanligen väcker intresse. Minskad förmåga att bli arg eller irriterad.","correct":0},{"id":8422,"text":"","correct":0},{"id":8423,"text":"Ointresserad av omvärlden. Upplevelser av likgiltighet inför vänner och bekanta.","correct":0},{"id":8424,"text":"","correct":0},{"id":8425,"text":"Total oförmåga att känna adekvat sorg eller vrede. Totalt eller smärtsam likgiltighet och oförmåga att uppleva känslor även för närstående.","correct":0}],"selectedAnswer":-1,"id":2577,"title":"Minskat känslomässigt engagemang","image":"","text":"Avser upplevelser av minskat intresse för omvärlden eller för sådana aktiviteter som vanligen bereder nöje eller glädje. Subjektiv oförmåga att reagera känslomässigt inför människor eller företeelser i omgivningen.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8426,"text":"Inga pessimistiska tankar.","correct":0},{"id":8427,"text":"","correct":0},{"id":8428,"text":"Fluktuerande självförebråelser och mindervärdesidéer.","correct":0},{"id":8429,"text":"","correct":0},{"id":8430,"text":"Ständiga självanklagelser. Klara, men inte orimliga, tankar om synd eller skuld. Uttalat pessimistisk framtidssyn.","correct":0},{"id":8431,"text":"","correct":0},{"id":8432,"text":"Absurda föreställningar om ekonomisk ruin och oförlåtliga synder. Absurda självanklagelser.","correct":0}],"selectedAnswer":-1,"id":2578,"title":"Depressivt tankeinnehåll","image":"","text":"Avser självförebråelser, självanklagelser, föreställningar om synd och skuld, mindervärdighet och ekonomisk ruin.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]},{"answers":[{"id":8433,"text":"Ordinär livslust. Inga självmordstankar.","correct":0},{"id":8434,"text":"","correct":0},{"id":8435,"text":"Livsleda, men inga eller endast vaga dödsönskningar","correct":0},{"id":8436,"text":"","correct":0},{"id":8437,"text":"Självmordstankar förekommer och självmord betraktas som en tänkbar utväg,men ingen bestämd självmordsavsikt.","correct":0},{"id":8438,"text":"","correct":0},{"id":8439,"text":"Uttalande avsikter att begå självmord, när tillfälle bjuds. Aktiva förberedelser för självmord.","correct":0}],"selectedAnswer":-1,"id":2579,"title":"Livsleda och själmordstankar","image":"","text":"Avser upplevelser av livsleda, dödsönskningar och självmordstankar samt förberedelser för självmord. Eventuella självmordsförsök påverkar ej i sig skattningen.","type":"calls_aspx.ChoiceQuestionDetails","isTrueFalse":false,"successFeedback":"","failFeedback":"","hint":"","solution":"","passed":false,"previousAnswers":[]}],"useTiming":false,"timeLimit":"00:00:00","answers":[null,null,null,null,null,null,null,null,null,null],"amountquestions":10,"resume":true,"lastPosition":"0:0","currentAssessmentPartID":0,"currentQuestionIndex":1,"assessmentResultID":134757,"percentToPass":100,"amountToPass":10})
			});
		}
		else {
			return lacapiProxy.doFetch("StartTestAndFetchQuestionDetails", { "navtreeid": navtreeid })
		}
	},

	getCurrentUserInfo: () => {
		return lacapiProxy.doFetch("GetCurrentUserInfo", { 'includevariables': 'true' });
	},

	getURLParameter: (name) => {
		name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
		var regexS = "[\\?&]" + name + "=([^&#]*)";
		var regex = new RegExp(regexS);
		var results = regex.exec(window.location.href);
		if (results == null)
			return null;
		else
			return results[1];
	},

	getStartXml: function (url) {
		var ajaxRequest = null;
		ajaxRequest = new XMLHttpRequest();
		ajaxRequest.open("GET", url, false);
		ajaxRequest.send(null);
		if (ajaxRequest.status == 200) {
			var str = ajaxRequest.responseText;
			//alert("Loaded: "+str);
			if (window.DOMParser) {
				return ajaxRequest.responseXML;
				//return (new DOMParser()).parseFromString(str, "text/xml");
			}
			else {
				var xmlDoc = new window.ActiveXObject("Microsoft.XMLDOM");
				xmlDoc.async = false;
				xmlDoc.loadXML(str);
				return xmlDoc;
			}
		}
		else {
			return "";
		}
	}
}
export default lacapiProxy;



// WEBPACK FOOTER //
// ./src/libs/lacapi.js